const doc = [({"da":({"js":({"users":({"confirmations":({"new":({"send_confirmation_email_again":"Send email til bekræftelse igen"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;